/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {FC} from 'react'
import {Redirect, Switch, Route} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {PublicRoutes} from './PublicRoutes'
import {Logout} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import { useAuth0} from '@auth0/auth0-react';
import { LayoutSplashScreen } from '../../_metronic/layout/core'
import { SSO_ENTRY_PATH, ssoAuthorizeParams } from '../../setup/auth0/ssoConnection'
import { SsoEntryPage } from '../modules/auth/SsoEntryPage'


const Routes: FC = () => {

  const { isAuthenticated, isLoading, buildAuthorizeUrl } = useAuth0();

  // const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)

  return (
    <Switch>
      {/* Rotas públicas - DEVEM vir primeiro para serem acessíveis sem autenticação */}
      <Route path='/nuvemshop'>
        <PublicRoutes />
      </Route>
      {/* Error pages - MUST be first to avoid auth check */}
      <Route path='/error' component={ErrorsPage} />
      <Route path='/logout' component={Logout} />
      
      {/* Porta de entrada do SSO: precisa vir antes do redirect, que casa com tudo.
          `exact` deixa `/sso/<connection>` seguir para o redirect com a connection. */}
      {!isAuthenticated && !isLoading && (
        <Route exact path={SSO_ENTRY_PATH} component={SsoEntryPage} />
      )}

      {!isAuthenticated && !isLoading ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route
      render={() => {
        // `connection` leva direto ao IdP do cliente, sem passar pela tela de
        // e-mail e senha. Vem da URL de entrada `/sso/<connection>` ou de um
        // login anterior neste navegador; sem nenhum dos dois, login normal.
        buildAuthorizeUrl(ssoAuthorizeParams(window.location.pathname)).then((url) => {
          window.location.replace(url);
        });
        
        return null;
      }}
    />
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from='/auth' to='/' />
      )}

      {/* A URL de entrada do SSO só escolhe a connection; autenticado, não é rota.
          Condicionado a `isAuthenticated`: solto, ele dispara durante o isLoading
          e manda para `/` antes de o Auth0 resolver se existe sessão. */}
      {isAuthenticated && <Redirect from={SSO_ENTRY_PATH} to='/' />}

      {isAuthenticated && (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      )}

      {isLoading && (
        <Route>
          <LayoutSplashScreen />
        </Route>
      )}
    </Switch>
  )
}

export {Routes}
